import request from './http'

// 获取公开配置（无需登录）
export function getPublicSettings() {
  return request({
    url: '/system/config/public/',
    method: 'get',
  })
}

// 获取全部配置（管理员）
export function getAllSettings() {
  return request({
    url: '/system/settings/',
    method: 'get',
  })
}

// 批量更新配置
export function updateSettings(data) {
  return request({
    url: '/system/settings/',
    method: 'post',
    data,
  })
}

// 上传系统图片
export function uploadSystemImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/system/upload/',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getAgreementCurrent(key) {
  return request({
    url: `/system/agreements/${key}/current/`,
    method: 'get',
  })
}

export function acceptAgreements(agreements) {
  return request({
    url: '/system/agreements/accept/',
    method: 'post',
    data: { agreements },
  })
}

export function publishAgreement(data) {
  return request({
    url: '/system/agreements/admin/publish/',
    method: 'post',
    data,
  })
}
